<!-- Bouton Retour au parcours appelant -->
<dsd-link-action type="return" class="dsd-mb-md">
  <a [href]="urlRetourParcoursExterne">{{ 'caad.button.retour' | translate }}</a>
</dsd-link-action>
